import { CUSTOMER_JOURNEY_MENU_SUCCESS } from './../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_MENU_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyMenuSuccess.js